import { Injectable, signal } from '@angular/core';

/**
 * Root-level store to trigger the breadcrumb's home dropdown to open.
 * Used for cross-component communication when the dropdown needs to be
 * programmatically opened (e.g., when no recent projects exist in embedded mode).
 */
@Injectable({ providedIn: 'root' })
export class BreadcrumbDropdownTriggerStore {
  private readonly _shouldOpenHomeDropdown = signal(false);
  readonly shouldOpenHomeDropdown = this._shouldOpenHomeDropdown.asReadonly();

  /**
   * Triggers the home dropdown to open.
   * The breadcrumb component will react and open the dropdown.
   */
  openHomeDropdown(): void {
    this._shouldOpenHomeDropdown.set(true);
  }

  /**
   * Resets the trigger after the dropdown has been opened.
   */
  resetTrigger(): void {
    this._shouldOpenHomeDropdown.set(false);
  }
}
